import type { IconProps } from "./types";

export function Trash({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
        ? color
        : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 2.09961C14.7403 2.09961 15.4672 2.36397 16.0166 2.8584C16.5689 3.35559 16.9003 4.05148 16.9004 4.7998V6.09961H21C21.4971 6.09961 21.9004 6.50294 21.9004 7C21.9004 7.49706 21.4971 7.90039 21 7.90039H19.9004V19.2002C19.9003 19.9485 19.5689 20.6444 19.0166 21.1416C18.4672 21.636 17.7403 21.9004 17 21.9004H7C6.25969 21.9004 5.53277 21.636 4.9834 21.1416C4.4311 20.6444 4.09967 19.9485 4.09961 19.2002V7.90039H3C2.50294 7.90039 2.09961 7.49706 2.09961 7C2.09961 6.50294 2.50294 6.09961 3 6.09961H7.09961V4.7998C7.09967 4.05148 7.4311 3.35559 7.9834 2.8584C8.53277 2.36397 9.25969 2.09961 10 2.09961H14ZM5.90039 19.2002C5.90045 19.4063 5.99009 19.6259 6.1875 19.8037C6.38828 19.9844 6.67945 20.0996 7 20.0996H17C17.3206 20.0996 17.6117 19.9844 17.8125 19.8037C18.0099 19.6259 18.0996 19.4063 18.0996 19.2002V7.90039H5.90039V19.2002ZM10 10.0996C10.4971 10.0996 10.9004 10.5029 10.9004 11V17C10.9004 17.4971 10.4971 17.9004 10 17.9004C9.50294 17.9004 9.09961 17.4971 9.09961 17V11C9.09961 10.5029 9.50294 10.0996 10 10.0996ZM14 10.0996C14.4971 10.0996 14.9004 10.5029 14.9004 11V17C14.9004 17.4971 14.4971 17.9004 14 17.9004C13.5029 17.9004 13.0996 17.4971 13.0996 17V11C13.0996 10.5029 13.5029 10.0996 14 10.0996ZM10 3.90039C9.67945 3.90039 9.38828 4.01559 9.1875 4.19629C8.99009 4.37408 8.90045 4.59369 8.90039 4.7998V6.09961H15.0996V4.7998C15.0996 4.59369 15.0099 4.37408 14.8125 4.19629C14.6117 4.01559 14.3206 3.90039 14 3.90039H10Z"
        fill={currentColor}
      />
    </svg>
  );
}
